export default __webpack_public_path__ + "static/Sequel-100-Wide-65-af5808b72e987be25bfdeffcffdcd016.ttf";